import { useContext } from 'react';
import GameContext from 'contexts/GameContext';
import useGameService from 'services/GameService';

import CheckboxAction from 'components/UserActions/PokerActions/CheckboxAction';

import 'components/UserActions/UserActions.scss';

const WaitForBigBlind = () => {
  const { waitForBB } = useGameService();
  const { preselectedAction, setPreselectedAction } = useContext(GameContext);

  const changeEvent = function () {
    setPreselectedAction('waitforbb');
    waitForBB();
  };

  return (
    <>
      <CheckboxAction
        label='Wait For Big Blind'
        value='waitforbb'
        onChange={changeEvent}
        // Only lit when the player actually picks it — dropping the
        // `preselectedAction === ''` default so BOTH join buttons render neutral
        // at rest and only turn gold once selected.
        checked={preselectedAction === 'waitforbb'}
        neutralUntilSelected
        activeVariant='raise'
        noDeselect
      />
    </>
  );
};

export default WaitForBigBlind;
